import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {OutboundCallIcon} from 'shells/icon/svg/outbound-call-icon';

import type {MeetingUpdateInput} from 'nutshell-graphql-types';

import {SmallModalContent} from './small-modal-content';
import {SmallModalFooter} from './small-modal-footer';

type Props = {
    id: string;
    onSave: (arg1: MeetingUpdateInput) => void;
    onFailToConnect: () => void;
    closeModal: () => void;
};

export function OutboundCallModalContent(props: Props) {
    return (
        <SmallModalContent
            header='Outbound phone call'
            icon={OutboundCallIcon}
            subheader='Participants will be asked to share their phone number when scheduling this meeting.'
        >
            <SmallModalFooter
                onFailToConnect={props.onFailToConnect}
                onSave={() => {
                    props.onSave({id: props.id, locationType: 'OUTBOUND_CALL', location: null});
                }}
                closeModal={props.closeModal}
            />
        </SmallModalContent>
    );
}
